<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pHx99r/tc-custom/9781504028356.jpg?1728259408083" alt="This image is the cover for the book Suspects"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Suspects
      </h1>
      <p class="bookDescription body article font2">
        <b>An NYPD detective investigates a double homicide in a Brooklyn candy store, in a thriller by the <i>New York Times</i>–bestselling author of <i>One Police Plaza</i>.</b><br/>  <br/> In Greenpoint, everyone comes to Yetta’s. A candy store one block west of McGoldrick Park, it’s a neighborhood landmark, the place where Brooklynites come to sip a soda, buy a paper, and argue about gentrification. But when Lt. Joe Gallagher comes by to drop off a birthday cake for Yetta, he doesn’t notice the homeless man standing outside. Gallagher has just handed over the cake when the man enters, drops his shopping bag, and pulls out a shotgun. The lieutenant doesn’t have time to reach his revolver before he’s blown away. Yetta is the next to die.<br/>  <br/> Investigating the double homicide, Det. Lt. Tony Scanlon discovers that Gallagher was more than an ordinary hard-drinking, hardworking Irish cop. And as more killings follow, Scanlon knows that this will be a summer of blood for the NYPD.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William J. Caunitz
      </h2>
      
      <p class="authorDescription body article">William J. Caunitz was a thirty-year veteran of the New York City Police Department. During his career, he achieved the rank of lieutenant and was assigned commander of a detective squad. At the age of fifty-one, Caunitz began publishing crime novels, which were noted for their realistic depictions of the daily workings of a police precinct, as well as for their sensational plots. He wrote seven novels, and the first, <I>One Police Plaza</I>, was made into a television movie. Caunitz died from pulmonary fibrosis in 1996. His last work, <I>Chains of Command</I>, which was halfway completed at the time, was finished by Christopher Newman, author of the Joe Dante series.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77021dc4